import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫大全',
    url: 'https://hanmandq.com',
    description: '韩漫漫画网站，汇聚众多好看韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门合集。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@hanmandq.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫大全有哪些优势？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫大全汇集了丰富的韩国漫画资源，支持韩漫在线免费阅读，涵盖恋爱、奇幻、动作、搞笑、剧情、悬疑、日常等多元化的热门合集。网站界面清晰友好，更新速度快，为读者提供流畅的高品质阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫大全上的漫画是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩漫大全上所有韩国漫画均支持免费在线观看，无需注册登录即可畅享阅读，让每一位韩漫爱好者都能无障碍地享受好看韩国漫画。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系韩漫大全？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过发送邮件至 contact@hanmandq.com 或添加客服QQ 1234567890 与我们取得联系。我们重视每一位读者的反馈和建议。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫大全会持续更新吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫大全保持每日更新，不断添加最新的韩国漫画内容和热门合集，确保读者能够第一时间阅读到最新的好看韩国漫画。',
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>关于我们 - 韩漫漫画网站_韩漫在线免费阅读_韩漫大全</title>
        <meta name="description" content="了解韩漫漫画网站的品牌故事与发展历程。韩漫大全致力于为读者提供最好看的韩国漫画，支持韩漫在线免费阅读，汇聚热门合集，打造优质韩漫阅读平台。" />
        <meta name="keywords" content="关于我们,韩漫漫画网站,好看韩国漫画,韩漫在线免费阅读,韩漫大全,热门合集" />
        <link rel="canonical" href="https://hanmandq.com/about" />
        <meta property="og:title" content="关于我们 - 韩漫漫画网站_韩漫在线免费阅读_韩漫大全" />
        <meta property="og:description" content="了解韩漫漫画网站的品牌故事与发展历程。韩漫大全致力于为读者提供最好看的韩国漫画。" />
        <meta property="og:url" content="https://hanmandq.com/about" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="关于我们 - 韩漫漫画网站_韩漫在线免费阅读_韩漫大全" />
        <meta name="twitter:description" content="了解韩漫漫画网站的品牌故事与发展历程。韩漫大全致力于为读者提供最好看的韩国漫画。" />
      </Helmet>

      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              关于我们
            </h1>
            <p className="text-sm text-foreground-500 mb-10">
              了解<strong>韩漫大全</strong>的品牌故事与发展历程
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
              <div>
                <h2 className="text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  <a href="#brand-intro">品牌介绍</a>
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    <strong>韩漫漫画网站</strong>（韩漫大全）成立于2024年，是一个专注于<strong>韩国漫画</strong>在线阅读的专业平台。
                    我们致力于为广大华语读者提供最优质的<strong>韩漫在线免费阅读</strong>体验，
                    汇集了涵盖恋爱、奇幻、动作、搞笑、剧情、悬疑、日常等多元化的<strong>好看韩国漫画</strong>作品。
                  </p>
                  <p>
                    韩漫大全以精选内容为核心，每一部漫画都经过编辑团队的精挑细选，
                    确保为读者提供高品质的阅读内容。我们与多家韩国漫画出版社和创作者保持紧密合作，
                    不断引入最新的<strong>热门合集</strong>，让读者能够第一时间接触到最新的韩国漫画作品。
                  </p>
                  <p>
                    随着韩流文化在全球范围内的持续升温，韩国漫画凭借其精美的画风、
                    紧凑的剧情和丰富的情感表达，赢得了越来越多华语读者的喜爱。
                    韩漫大全正是顺应这一趋势而诞生的在线阅读平台，旨在架起韩国漫画与华语读者之间的桥梁。
                  </p>
                </div>
              </div>

              <div className="rounded-lg overflow-hidden h-[300px] lg:h-auto">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%20art%20style%20collage%20with%20multiple%20genre%20characters%2C%20warm%20cozy%20reading%20atmosphere%2C%20soft%20lighting%2C%20bookshelf%20background%2C%20artistic%20composition%2C%20vibrant%20yet%20soft%20color%20palette%2C%20no%20text&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="韩漫漫画网站 - 品牌形象展示"
                  title="韩漫大全 - 好看韩国漫画在线阅读平台"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                <a href="#reputation">口碑与评价</a>
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {[
                  {
                    name: '漫画爱好者小林',
                    text: '韩漫大全是我每天必逛的网站，更新速度快，分类清晰，画质也很棒。强烈推荐给喜欢韩国漫画的朋友！',
                    rating: 5,
                  },
                  {
                    name: '资深读者阿杰',
                    text: '一直在找能稳定看韩漫的平台，终于在这里找到了。漫画种类丰富，热门合集更新及时，阅读体验非常好。',
                    rating: 5,
                  },
                  {
                    name: '韩漫新粉丝小美',
                    text: '刚接触韩国漫画的时候朋友推荐了韩漫大全，界面简洁好看，免费阅读太友好了，已经成了我的日常娱乐。',
                    rating: 5,
                  },
                  {
                    name: '二次元爱好者大宇',
                    text: '韩漫大全的热门合集做得很到位，推荐的漫画质量都很高，基本上点击进去就不会失望，非常良心的平台。',
                    rating: 5,
                  },
                  {
                    name: '漫画博主思思',
                    text: '作为漫画内容创作者，我很欣赏韩漫大全的选品眼光。平台上的好看韩国漫画确实都是精品，值得信赖。',
                    rating: 5,
                  },
                  {
                    name: '学生党读者小周',
                    text: '免费阅读对学生党太友好了！每天放学回家打开韩漫大全看一话漫画，已经成了我的放松方式。好评！',
                    rating: 4,
                  },
                ].map((review, index) => (
                  <div key={index} className="p-5 rounded-lg bg-background-100/70">
                    <div className="flex items-center gap-0.5 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">{review.text}</p>
                    <p className="text-xs text-foreground-400 font-medium">{review.name}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                <a href="#contact">联系我们</a>
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="p-5 rounded-lg bg-background-100/70 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-600">contact@hanmandq.com</p>
                    <p className="text-xs text-foreground-400 mt-1">工作日24小时内回复</p>
                  </div>
                </div>
                <div className="p-5 rounded-lg bg-background-100/70 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-customer-service-line text-lg text-secondary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">在线客服</h3>
                    <p className="text-sm text-foreground-600">QQ：1234567890</p>
                    <p className="text-xs text-foreground-400 mt-1">工作日 9:00 - 18:00</p>
                  </div>
                </div>
                <div className="p-5 rounded-lg bg-background-100/70 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-feedback-line text-lg text-accent-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">意见反馈</h3>
                    <p className="text-sm text-foreground-600">欢迎提供宝贵建议</p>
                    <p className="text-xs text-foreground-400 mt-1">帮助我们做得更好</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}